export const TwitterIcon = () => {
  return (
    <svg
      width="1200"
      height="1227"
      viewBox="0 0 1200 1227"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
        fill="white"
      />
    </svg>
  )
}

export const LinkedInIcon = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.21875 1.62626C0.21875 1.15487 0.387674 0.765984 0.725507 0.459596C1.06334 0.153194 1.50254 0 2.04307 0C2.57397 0 3.00349 0.150832 3.33168 0.452525C3.66952 0.763636 3.83844 1.16901 3.83844 1.66869C3.83844 2.12121 3.67435 2.49831 3.34616 2.8C3.00833 3.11111 2.56431 3.26667 2.01412 3.26667H1.99964C1.46875 3.26667 1.03922 3.11111 0.711028 2.8C0.382838 2.48889 0.21875 2.09764 0.21875 1.62626ZM0.406974 14V4.55354H3.62126V14H0.406974ZM5.40215 14H8.61643V8.72525C8.61643 8.39528 8.65505 8.14073 8.73226 7.96162C8.86739 7.64107 9.07251 7.37002 9.34761 7.14848C9.62271 6.92693 9.96778 6.81616 10.3828 6.81616C11.4639 6.81616 12.0045 7.52794 12.0045 8.95152V14H15.2188V8.58384C15.2188 7.18855 14.8809 6.1303 14.2052 5.40909C13.5296 4.68788 12.6367 4.32727 11.5267 4.32727C10.2815 4.32727 9.31141 4.85051 8.61643 5.89697V5.92525H8.60195L8.61643 5.89697V4.55354H5.40215C5.42145 4.85521 5.43111 5.79326 5.43111 7.36768C5.43111 8.94208 5.42145 11.1529 5.40215 14Z"
        fill="white"
      />
    </svg>
  )
}

export const FacebookIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7188 8.04889C16.7188 3.60361 13.137 0 8.71875 0C4.30047 0 0.71875 3.60361 0.71875 8.04889C0.71875 12.0663 3.64422 15.3962 7.46875 16V10.3755H5.4375V8.04889H7.46875V6.27562C7.46875 4.25837 8.66313 3.1441 10.4905 3.1441C11.3655 3.1441 12.2812 3.3013 12.2812 3.3013V5.28208H11.2725C10.2788 5.28208 9.96875 5.90257 9.96875 6.53972V8.04889H12.1875L11.8328 10.3755H9.96875V16C13.7933 15.3962 16.7188 12.0663 16.7188 8.04889Z"
        fill="white"
      />
    </svg>
  )
}

export const YouTubeIcon = () => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8398 0.358209C16.6003 0.58209 17.1819 1.16418 17.3609 1.8806C17.7188 3.22388 17.7188 6 17.7188 6C17.7188 6 17.7188 8.77612 17.3609 10.1194C17.1372 10.8806 16.5556 11.4627 15.8398 11.6418C14.5424 12 9.21875 12 9.21875 12C9.21875 12 3.9398 12 2.5977 11.6418C1.83717 11.4179 1.25559 10.8358 1.07664 10.1194C0.71875 8.77612 0.71875 6 0.71875 6C0.71875 6 0.71875 3.22388 1.07664 1.8806C1.25559 1.1194 1.83717 0.537313 2.55296 0.358209C3.89507 0 9.21875 0 9.21875 0C9.21875 0 14.4977 0 15.8398 0.358209ZM7.474 3.44775V8.50745L11.9029 5.99999L7.474 3.44775Z"
        fill="white"
      />
    </svg>
  )
}

export const InstagramIcon = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.21877 3.15002C5.36877 3.15002 3.86877 4.65002 3.86877 6.50002C3.86877 8.35002 5.36877 9.85003 7.21877 9.85003C9.06877 9.85003 10.5688 8.35002 10.5688 6.50002C10.5688 4.65002 9.06877 3.15002 7.21877 3.15002ZM7.21877 8.65002C6.01877 8.65002 5.06877 7.70002 5.06877 6.50002C5.06877 5.30002 6.01877 4.35002 7.21877 4.35002C8.41877 4.35002 9.36877 5.30002 9.36877 6.50002C9.36877 7.70002 8.41877 8.65002 7.21877 8.65002Z"
        fill="white"
      />
      <path
        d="M10.6689 3.85005C11.1189 3.85005 11.4689 3.50005 11.4689 3.05005C11.4689 2.60005 11.1189 2.25005 10.6689 2.25005C10.2189 2.25005 9.8689 2.60005 9.8689 3.05005C9.8689 3.50005 10.2189 3.85005 10.6689 3.85005Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.21875 0C5.46875 0 5.21875 0 4.51875 0.05C3.86875 0.05 3.36875 0.2 2.96875 0.35C2.51875 0.5 2.16875 0.75 1.81875 1.1C1.46875 1.45 1.21875 1.8 1.06875 2.25C0.91875 2.65 0.76875 3.15 0.76875 3.8C0.71875 4.5 0.71875 4.75 0.71875 6.5C0.71875 8.25 0.71875 8.5 0.76875 9.2C0.81875 9.9 0.91875 10.35 1.06875 10.8C1.21875 11.25 1.46875 11.6 1.81875 11.95C2.16875 12.3 2.51875 12.55 2.96875 12.7C3.36875 12.85 3.86875 12.95 4.56875 13H7.21875C8.96875 13 9.21875 13 9.91875 12.95C10.6187 12.9 11.0688 12.8 11.5188 12.65C11.9688 12.5 12.3188 12.25 12.6687 11.9C13.0188 11.55 13.2688 11.2 13.4188 10.75C13.5688 10.35 13.6688 9.85 13.7188 9.15V6.5C13.7188 4.75 13.7188 4.5 13.6688 3.8C13.6188 3.1 13.5188 2.65 13.3688 2.2C13.2188 1.75 12.9688 1.4 12.6187 1.05C12.2687 0.7 11.9188 0.45 11.4688 0.3C11.0688 0.15 10.5687 0.05 9.86875 0H7.21875ZM7.21875 1.15C8.96875 1.15 9.16875 1.15 9.86875 1.2C10.4635 1.24575 10.8071 1.33336 11.0144 1.38623L11.0688 1.4C11.3688 1.5 11.5688 1.65 11.8188 1.9C12.0688 2.15 12.1688 2.35 12.3188 2.65C12.4188 2.9 12.5188 3.2 12.5188 3.85C12.5688 4.55 12.5688 4.75 12.5688 6.5C12.5688 8.25 12.5688 8.45 12.5188 9.15C12.473 9.74475 12.3854 10.0883 12.3325 10.2957L12.3188 10.35C12.2188 10.65 12.0688 10.85 11.8188 11.1C11.5688 11.35 11.3688 11.45 11.0688 11.6C10.8188 11.7 10.5188 11.8 9.86875 11.8C9.16875 11.85 8.96875 11.85 7.21875 11.85C5.46875 11.85 5.26875 11.85 4.56875 11.8C3.974 11.7543 3.63042 11.6666 3.4231 11.6138L3.36875 11.6C3.06875 11.5 2.86875 11.35 2.61875 11.1C2.36875 10.85 2.26875 10.65 2.11875 10.35C2.01875 10.1 1.91875 9.8 1.91875 9.15C1.86875 8.45 1.86875 8.25 1.86875 6.5C1.86875 4.75 1.86875 4.55 1.91875 3.85C1.9645 3.25525 2.05211 2.91167 2.10498 2.70434L2.11875 2.65C2.21875 2.35 2.36875 2.15 2.61875 1.9C2.86875 1.65 3.06875 1.55 3.36875 1.4C3.61875 1.3 3.91875 1.2 4.56875 1.2C4.83995 1.2 5.0361 1.1925 5.27641 1.1833C5.65637 1.16876 6.14675 1.15 7.21875 1.15Z"
        fill="white"
      />
    </svg>
  )
}
